import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.5 17v-7m0-2V6" stroke="currentColor" fill="none" /></svg>;